import { render, staticRenderFns } from "./HardwareStats.vue?vue&type=template&id=2f72024f&scoped=true&"
import script from "./HardwareStats.vue?vue&type=script&lang=js&"
export * from "./HardwareStats.vue?vue&type=script&lang=js&"
import style0 from "./HardwareStats.vue?vue&type=style&index=0&id=2f72024f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72024f",
  null
  
)

export default component.exports